/**
 *
 * See https://en.wikipedia.org/wiki/ABA_routing_transit_number#Check_digit
 * Validates whether a routing number is valid
 */
export const abaChecksum = (routingNumber?: string) => {
  if (!routingNumber) {
    return false;
  }
  if (routingNumber.length !== 9) {
    return false;
  }
  const cArray = routingNumber.split("").map((c) => parseInt(c, 10));
  const cSum =
    3 * (cArray[0] + cArray[3] + cArray[6]) +
    7 * (cArray[1] + cArray[4] + cArray[7]) +
    (cArray[2] + cArray[5] + cArray[8]);
  return cSum % 10 === 0;
};
